import styled from '@emotion/styled';

export const LendingTermsComponentStyled = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  height: '100vh',
  '.language-selector-container': {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    margin: '1rem 0rem',
    justifyContent: 'flex-start',
    '.language-heading': {
      marginRight: 10
    },
    '.language-selector': {
      color: 'black',
      fontSize: '14px'
    }
  },
  '.language-options': {
    fontSize: '14px'
  },
  '.iframe': {
    height: '100%',
    width: '100%'
  }
});
